import { Box, Typography } from '@mui/material'
import { programSectionWrapperSx } from '../programs/programLayout'
import { MOBILE_MQ, mobileBodyTextSx, mobileSectionPy, mobileSectionTitleSx } from '../../theme/mobileLayout'

export default function EventsPageHero() {
  return (
    <Box
      component="section"
      sx={{
        ...programSectionWrapperSx,
        pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
        pb: mobileSectionPy,
      }}
    >
      <Box
        sx={{
          maxWidth: 1068,
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          alignItems: 'center',
          textAlign: 'center',
          [MOBILE_MQ]: { gap: '16px' },
        }}
      >
        <Typography
          component="h1"
          sx={{
            ...mobileSectionTitleSx,
            fontSize: { ...mobileSectionTitleSx.fontSize, lg: 80 },
          }}
        >
          Our Events & Programs
        </Typography>
        <Typography
          sx={{
            ...mobileBodyTextSx,
            maxWidth: 1068,
          }}
        >
          Explore our diverse range of programs and events designed to empower youth and build
          stronger communities
        </Typography>
      </Box>
    </Box>
  )
}
